// Mock data for Veetu Saama — icon-first version

export const brandLogos = [
  { name: 'LG', text: 'LG' },
  { name: 'Dyson', text: 'dyson' },
  { name: 'Hafele', text: 'HÄFELE' },
  { name: 'Faber', text: 'FABER' },
  { name: 'Aquaguard', text: 'Aquaguard' },
  { name: 'Samsung', text: 'SAMSUNG' },
  { name: 'IFB', text: 'IFB' },
  { name: 'Bosch', text: 'BOSCH' },
  { name: 'Preethi', text: 'Preethi' },
  { name: 'Prestige', text: 'Prestige' },
  { name: 'Butterfly', text: 'Butterfly' },
  { name: 'Hawkins', text: 'Hawkins' },
];

export const heroHighlights = [
  { id: 1, icon: 'ChefHat', title: 'Kitchens' },
  { id: 2, icon: 'Sofa', title: 'Living' },
  { id: 3, icon: 'BedDouble', title: 'Bedrooms' },
  { id: 4, icon: 'Refrigerator', title: 'Appliances' },
];

// Four hero categories — icon-based
export const categories = [
  { id: 1, name: 'Cookware', icon: 'CookingPot', tint: '#F58220', desc: 'Everyday essentials' },
  { id: 2, name: 'Metal Vessel', icon: 'UtensilsCrossed', tint: '#4D4D4D', desc: 'Heirloom quality' },
  { id: 3, name: 'Accessories', icon: 'Sparkles', tint: '#F58220', desc: 'Finishing touches' },
  { id: 4, name: 'Appliances', icon: 'Zap', tint: '#4D4D4D', desc: 'Modern efficiency' },
];

// Premium collections — icon-based
export const premiumCollections = [
  { id: 1, name: 'Cookware', icon: 'CookingPot' },
  { id: 2, name: 'Cast Iron', icon: 'Flame' },
  { id: 3, name: 'Cleaner', icon: 'SprayCan' },
  { id: 4, name: 'Cooker', icon: 'Soup' },
  { id: 5, name: 'Lunch Box', icon: 'Package' },
  { id: 6, name: 'Iron Box', icon: 'Shirt' },
  { id: 7, name: 'OTG', icon: 'Microwave' },
];

// Innovative solutions — icon-based
export const innovativeSolutions = [
  { id: 1, name: 'Induction', icon: 'CircleDot' },
  { id: 2, name: 'Mixer', icon: 'Blender' },
  { id: 3, name: 'Refrigerator', icon: 'Refrigerator' },
  { id: 4, name: 'Dry Cleaner', icon: 'WashingMachine' },
  { id: 5, name: 'A.C', icon: 'Snowflake' },
  { id: 6, name: 'Chimney', icon: 'Wind' },
  { id: 7, name: 'Air Fryer', icon: 'Utensils' },
];

// Popular products — icon-based per brand
export const popularProducts = [
  {
    id: 1,
    brand: 'Hawkins',
    tagline: 'Trusted pressure cookers',
    items: [
      { name: 'Kadhai', icon: 'CookingPot' },
      { name: 'Tadka Pan', icon: 'Utensils' },
    ],
  },
  {
    id: 2,
    brand: 'Stovekraft',
    tagline: 'Smart cooking, made easy',
    items: [
      { name: 'I Smart', icon: 'Flame' },
      { name: '3 Burner Stove', icon: 'ChefHat' },
    ],
  },
  {
    id: 3,
    brand: 'Faber',
    tagline: 'Modern chimneys & hobs',
    items: [
      { name: 'Pro HT 905 BR CI', icon: 'Wind' },
      { name: 'FB10 80L 10F GLM', icon: 'Microwave' },
    ],
  },
  {
    id: 4,
    brand: 'Meyer',
    tagline: 'Precision cookware',
    items: [
      { name: 'Mini Fry Pan', icon: 'CookingPot' },
      { name: 'Covered Kadai', icon: 'Soup' },
    ],
  },
  {
    id: 5,
    brand: 'Mirror',
    tagline: 'Everyday storage',
    items: [
      { name: 'Conical Barni', icon: 'Package' },
    ],
  },
  {
    id: 6,
    brand: 'Preethi',
    tagline: 'Efficient kitchen appliances',
    items: [
      { name: 'Midora 81', icon: 'Blender' },
    ],
  },
  {
    id: 7,
    brand: 'Prestige',
    tagline: 'Home essentials',
    items: [
      { name: 'Zodiac Glitter', icon: 'Utensils' },
    ],
  },
];

export const services = [
  {
    id: 1,
    title: 'Wide Range of Branded',
    description:
      'Veetu Saama Store offers a curated selection of home appliances from top brands like LG, IFB, Preethi, Prestige, Butterfly, and more. From kitchen essentials to large appliances, customers can find products that match their lifestyle, budget, and brand preferences—all under one roof.',
    icon: 'Sparkles',
  },
  {
    id: 2,
    title: 'Competitive Pricing & Offers',
    description:
      'Veetu Saama Store is known for offering affordable pricing along with regular deals, festive discounts, and bundled offers. This makes it a cost-effective option for families looking to furnish or upgrade their homes without compromising on quality.',
    icon: 'BadgePercent',
  },
  {
    id: 3,
    title: 'Timely Delivery & Installation',
    description:
      'Veetu Saama ensures prompt delivery of appliances and supports hassle-free installation by certified technicians. The delivery process is smooth, with clear communication and minimal delays, helping customers set up their products quickly.',
    icon: 'Truck',
  },
  {
    id: 4,
    title: 'Reliable After-Sales Support',
    description:
      "Customer satisfaction doesn't end at the sale—Veetu Saama offers strong after-sales service including product demos, service booking assistance, and warranty support. This builds trust and ensures a worry-free experience for customers even after purchase.",
    icon: 'HeartHandshake',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Varalakshmi Sridhar',
    city: 'Chennai',
    rating: 5,
    text: 'Must visit shop; as they have an amazing collection of kitchen appliances and vessels. Very unique designs too. I loved their collections of serving bowls and coffee filters per say.',
  },
  {
    id: 2,
    name: 'Mr. Gamer Empire',
    city: 'Chennai',
    rating: 5,
    text: 'I recently visited Veetu Saama in Adyar and was quite impressed with their collection of premium utensils and kitchen appliances. The store has a unique selection, and excellent staff.',
  },
  {
    id: 3,
    name: 'Raj Mohan',
    city: 'Chennai',
    rating: 5,
    text: 'One of the best store to buy appliances, utensils, furniture. Good quality and affordable prices.',
  },
];

export const supportOptions = [
  {
    id: 1,
    title: 'Register your Complaint',
    description: 'Submit your complaint online, and our support team will contact you promptly.',
    cta: 'Register Now',
    icon: 'ClipboardList',
    action: 'register',
  },
  {
    id: 2,
    title: 'Whatsapp me',
    description: "Can't register a complaint? Message us on WhatsApp – we've got you covered!",
    cta: 'Chat Now',
    icon: 'MessageCircle',
    action: 'whatsapp',
    link: 'https://wa.me/917305970386',
  },
  {
    id: 3,
    title: 'Visit our Store',
    description: 'Reach out to our support team or visit the service center closest to you.',
    cta: 'Visit Here',
    icon: 'MapPin',
    action: 'visit',
    link: 'https://g.co/kgs/SG7jk9g',
  },
];

export const navLinks = [
  { label: 'Homes', href: '#home' },
  { label: 'Appliances', href: '#collections' },
  { label: 'Lifestyle', href: '#solutions' },
  { label: 'Together', href: '#contact' },
];

// Store experience tiles — curated stand-ins for @veetusaama Instagram
export const storeMoments = [
  {
    id: 1,
    icon: 'Store',
    title: 'Step Inside',
    caption: 'A walk through our Adyar showroom.',
    tag: 'Store Tour',
    stat: '2.1k likes',
  },
  {
    id: 2,
    icon: 'ChefHat',
    title: 'Live Cooking Demo',
    caption: 'Faber Hobtop Utopia in action.',
    tag: 'Demo',
    stat: '1.4k likes',
  },
  {
    id: 3,
    icon: 'BadgePercent',
    title: 'Festive Offers',
    caption: 'Diwali specials on premium cookware.',
    tag: 'Offer',
    stat: '3.6k likes',
  },
  {
    id: 4,
    icon: 'Users',
    title: 'Happy Homes',
    caption: 'Meet the families we serve every day.',
    tag: 'Community',
    stat: '2.8k likes',
  },
  {
    id: 5,
    icon: 'Sparkles',
    title: 'New Arrivals',
    caption: 'Fresh picks in appliances & lifestyle.',
    tag: 'New',
    stat: '1.9k likes',
  },
  {
    id: 6,
    icon: 'HeartHandshake',
    title: 'Behind the Service',
    caption: 'The team that keeps every home happy.',
    tag: 'Team',
    stat: '2.3k likes',
  },
  {
    id: 7,
    icon: 'Truck',
    title: 'Delivered with Care',
    caption: 'Installed and demoed at your doorstep.',
    tag: 'Delivery',
    stat: '1.1k likes',
  },
  {
    id: 8,
    icon: 'Award',
    title: 'Brand Partners',
    caption: 'Trusted authorised dealer badge.',
    tag: 'Trust',
    stat: '980 likes',
  },
];
